import { Navigate } from "react-router-dom";
import ForgotPassword from "pages/Auth/ForgotPassword";
import Login from "pages/Auth/Login";
import Dashboard from "pages/Dashboard";
import Bookings from "pages/Bookings";
import Users from "pages/Users";
import Logout from "pages/Auth/Logout";

const authProtectedRoutes = [
  { path: "/dashboards", element: <Dashboard /> },
  { path: "/bookings", element: <Bookings /> },
  { path: "/users", element: <Users /> },
  { path: "/logout", element: <Logout /> },

  { path: "*", element: <Navigate to="/dashboards" replace /> },
];

const publicRoutes = [
  { path: "/login", element: <Login /> },
  { path: "/forgot-password", element: <ForgotPassword /> },
];

export { authProtectedRoutes, publicRoutes };
